import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { bool, func, object, shape, string } from 'prop-types';
import { TextBase } from "../../../internal/TextBase";
import Radio from '../../../Radio';
import { cvcValidation, getIconByType, getTextField, normalizeCVV } from '../../helpers';
import styles from './Card.css';
var cx = classNames.bind(styles);
export var Card = function Card(_ref) {
  var item = _ref.item,
      disabled = _ref.disabled,
      method = _ref.method,
      themeRadio = _ref.themeRadio,
      mobile = _ref.mobile,
      onChangePaymentMethod = _ref.onChangePaymentMethod,
      messages = _ref.messages,
      form = _ref.form;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", {
      className: cx('card', {
        'disable-pointer-events': disabled
      }),
      onClick: onChangePaymentMethod(item.id, form, disabled),
      role: "button",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('radio')
    }, /*#__PURE__*/React.createElement(Radio, {
      id: item.id,
      checked: method === item.id,
      theme: themeRadio,
      onChange: onChangePaymentMethod(item.id, form, disabled),
      disabled: disabled
    })), /*#__PURE__*/React.createElement("span", {
      className: cx('card-icon')
    }, getIconByType(item.type)), /*#__PURE__*/React.createElement(TextBase, {
      size: "l",
      as: "span"
    }, item.number), /*#__PURE__*/React.createElement("span", {
      className: cx('card-expiration')
    }, /*#__PURE__*/React.createElement(TextBase, {
      size: "l",
      as: "span"
    }, item.expiration)), method === item.id && /*#__PURE__*/React.createElement("div", {
      className: cx('card-cvc')
    }, getTextField('cvc', _objectSpread({
      autoComplete: 'cc-csc',
      disabled: disabled,
      hideEye: true,
      placeholder: messages.cvc,
      maxLength: 4,
      mobile: mobile,
      parse: normalizeCVV,
      type: 'password'
    }, {
      validate: cvcValidation({
        requiredText: mobile ? messages.required : messages.requiredShort,
        isRequired: !(item.type.toLowerCase() === 'mastercard')
      })
    }))))
  );
};
Card.propTypes = process.env.NODE_ENV !== "production" ? {
  disabled: bool,
  item: object,
  method: string,
  themeRadio: string,
  mobile: bool,
  onChangePaymentMethod: func,
  form: object,
  messages: shape({
    cvc: string,
    required: string,
    requiredShort: string
  })
} : {};